<kui-color-picker id="{{ field.id }}"
    [color]="value"
    size="large"
    [position]="field.options?.position || 'left'"
    (onChange)="changeColor($event)"></kui-color-picker>